// extracted by mini-css-extract-plugin
export default {"formHeading":"aX-z","form":"bX-z","submitBtn":"cX-z","disabled":"dX-z","input":"eX-z","error":"fX-z","submitMsg":"gX-z","signIn":"hX-z"};